import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

Sentry.init({
  dsn: 'https://42ecffd112fb97efa8e8c60dbf21af24@o4510397963304960.ingest.de.sentry.io/4510397967040592',

  integrations: [],
  beforeSend(event, hint) {
    // Check if the error is from localhost
    const isLocalhost =
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';

    // If it's from localhost, return null to prevent sending the error
    if (isLocalhost) {
      return null;
    }

    return event;
  },
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
